export default __webpack_public_path__ + "static/usa_ohio_classic_lotto-9f788d39c431fb7eba276f8b4ea8a766.png";